'use client';

import { useEffect, useState } from 'react';

import { clsx } from 'clsx';
import Cookies from 'js-cookie';
import Link from 'next/link';

import { PHONE_NUMBER_LINK } from '@shared/constants/contacts';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { VStack } from '@shared/ui/Stack';
import { AlertModal } from '@widgets/AlertModal';
import { AttentionPlate } from '@widgets/AttentionPlate/AttentionPlate';
import { AuthModal } from '@widgets/Auth';
import { CallModal } from '@widgets/CallModal';
import { AboutCookieModal, AcceptCookieModal, openAcceptCookieModal } from '@widgets/CookieModals';

import cls from './ModalsContainer.module.scss';

const SESSION_ATTENTION_NAME = 'attentionPlate';
// const SESSION_HOLIDAYS_NAME = 'holidaysPlate';

export const ModalsContainer = () => {
  const dispatch = useAppDispatch();

  const [openAttentionPlate, setOpenAttentionPlate] = useState(false);
  // const [openHolidaysPlate, setOpenHolidaysPlate] = useState(false);

  const isAlertModalOpen = useAppSelector((state) => state.alert.isOpen);
  const isCallModalOpen = useAppSelector((state) => state.callModal.openModal);
  const isAcceptCookieModalOpen = useAppSelector((state) => state.cookieModal.acceptCookie);
  const isAboutCookieModalOpen = useAppSelector((state) => state.cookieModal.aboutCookie);
  const isAuthModalOpen = useAppSelector((state) => state.auth.modalIsOpen);

  const showCookieModal = Cookies.get('cookieAgreement') !== '1';

  const toggleOpenAttentionPlate = () => {
    setOpenAttentionPlate((prev) => {
      if (prev) {
        sessionStorage.setItem(SESSION_ATTENTION_NAME, '1');
      }

      return !prev;
    });
  };

  // const toggleOpenHolidaysPlate = () => {
  //   setOpenHolidaysPlate((prev) => {
  //     if (prev) {
  //       sessionStorage.setItem(SESSION_HOLIDAYS_NAME, '1');
  //     }
  //
  //     return !prev;
  //   });
  // };

  useEffect(() => {
    if (showCookieModal) {
      setTimeout(() => {
        dispatch(openAcceptCookieModal());
      }, 2000);
    }
  }, [dispatch, showCookieModal]);

  useEffect(() => {
    setTimeout(() => {
      if (!sessionStorage.getItem(SESSION_ATTENTION_NAME)) {
        toggleOpenAttentionPlate();
      }

      // if (!sessionStorage.getItem(SESSION_HOLIDAYS_NAME)) {
      //   toggleOpenHolidaysPlate();
      // }
    }, 2000);
  }, []);

  return (
    <>
      {isAlertModalOpen && <AlertModal />}

      {isCallModalOpen && <CallModal />}

      {isAuthModalOpen && <AuthModal />}

      <VStack className={cls.platesWrapper}>
        {/*{openHolidaysPlate && (*/}
        {/*  <AttentionPlate*/}
        {/*    className={clsx(cls.holidaysPlate)}*/}
        {/*    open={openHolidaysPlate}*/}
        {/*    toggleOpen={toggleOpenHolidaysPlate}*/}
        {/*  >*/}
        {/*    Уважаемые клиенты!*/}
        {/*    <br />С 31 декабря по&nbsp;11&nbsp;января компания Olevaro уходит на&nbsp;новогодние праздники.*/}
        {/*    <br />*/}
        {/*    Все заявки, оформленные на&nbsp;сайте в&nbsp;это время, обязательно будут приняты и обработаны*/}
        {/*    12&nbsp;января&nbsp;2026&nbsp;года в&nbsp;порядке очереди. Мы&nbsp;ценим ваше время и&nbsp;заранее*/}
        {/*    благодарим за&nbsp;доверие. С&nbsp;заботой, команда Olevaro!*/}
        {/*  </AttentionPlate>*/}
        {/*)}*/}

        {openAttentionPlate && (
          <AttentionPlate
            className={clsx(cls.attentionPlate)}
            open={openAttentionPlate}
            toggleOpen={toggleOpenAttentionPlate}
          >
            Некоторые функции сайта находятся в тестировании. По всем вопросам обращайтесь по номеру{' '}
            <Link
              aria-label={`Позвонить на номер ${PHONE_NUMBER_LINK}`}
              href={`tel:${PHONE_NUMBER_LINK}`}
              className={cls.attentionPhone}
            >
              8&nbsp;(800)&nbsp;100&nbsp;40&nbsp;76
            </Link>
          </AttentionPlate>
        )}

        {isAcceptCookieModalOpen && <AcceptCookieModal />}

        {isAboutCookieModalOpen && <AboutCookieModal />}
      </VStack>
    </>
  );
};
